import { ChangeDetectionStrategy, Component, InputSignal, OutputEmitterRef, input, output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'mp-file-upload-button',
  templateUrl: './file-upload-button.component.html',
  styleUrl: './file-upload-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, MatButton],
})
export class FileUploadButtonComponent {
  readonly disabled: InputSignal<boolean> = input<boolean>(false);

  readonly supportedFileTypeExtensions: InputSignal<string> = input<string>('*');

  readonly fileUpload: OutputEmitterRef<FileList> = output<FileList>();

  onFileUpload(event: Event): void {
    const target: HTMLInputElement = event.target as HTMLInputElement;
    const files: FileList | null = target.files;

    if (files) {
      this.fileUpload.emit(files);
    }

    // NOTE: This is done to ensure that onChange event will be triggered if user will select the same file
    target.value = '';
  }
}
